(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mk-creator-carousel"] && !Shopify.designMode) return;
  try {
    const MK_CC_TABLET = 1024;
  const MK_CC_MOBILE = 589;

  class MkCreatorCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.viewport || !this.track) return;

      /* Le jeu de photos d'origine, avant duplication. */
      this.originals = Array.from(this.track.children);
      if (!this.originals.length) return;

      this.mobileQuery = window.matchMedia(`(max-width: ${MK_CC_MOBILE}px)`);
      this.tabletQuery = window.matchMedia(`(max-width: ${MK_CC_TABLET}px)`);

      /* Rien au chargement de la page : le carrousel est sous la ligne de
         flottaison, la mise en page CSS suffit à l'afficher correctement. On
         duplique et on calcule seulement quand il approche de l'écran. */
      this.initObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) this.initOnce();
        },
        { rootMargin: '600px 0px' }
      );
      this.initObserver.observe(this);

      /* Filet de sécurité : si l'observateur ne se déclenchait jamais (page
         restée en arrière-plan, navigateur intégré d'une app), la boucle ne se
         créerait jamais. On initialise donc quand même, bien après le rendu. */
      this.initFallback = setTimeout(() => this.initOnce(), 5000);
    }

    initOnce() {
      if (this.initialized) return;
      this.initialized = true;
      clearTimeout(this.initFallback);
      this.initObserver.disconnect();
      this.init();
    }

    init() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = false;
      this.visible = true;
      this.activeIndex = -1;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.debounce(() => this.layout(), 200);

      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      /* On observe la largeur du carrousel, pas la fenêtre : sur téléphone, la
         barre d'adresse qui se replie au défilement déclenche un resize de la
         fenêtre sans changer la largeur, ce qui remettait le carrousel au
         départ et relançait la minuterie en boucle. */
      this.resizeObserver = new ResizeObserver(() => this.onResize());
      this.resizeObserver.observe(this.viewport);

      /* En tournant l'écran, la largeur peut être à jour avant le palier
         (mobile, tablette). On recalcule donc aussi à chaque changement de
         palier, sinon le carrousel garderait la mise en page de l'ancien. */
      this.onBreakpoint = () => this.layout();
      this.mobileQuery.addEventListener('change', this.onBreakpoint);
      this.tabletQuery.addEventListener('change', this.onBreakpoint);

      /* Sur mobile, un toucher déclenche aussi pointerenter, mais pointerleave
         n'arrive qu'au toucher suivant ailleurs : le carrousel restait figé.
         Le survol ne met donc en pause qu'avec une vraie souris. */
      /* Le survol est détecté sur la zone des photos seulement : passer la
         souris sur le titre ou la marge de la section ne coupe pas le défilement. */
      this.viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.pause();
      });
      this.viewport.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.resume();
      });
      this.viewport.addEventListener('touchstart', () => this.pause(), { passive: true });
      this.viewport.addEventListener('touchend', () => this.resumeLater(), { passive: true });
      this.viewport.addEventListener('touchcancel', () => this.resumeLater(), { passive: true });

      this.setupMouseDrag();

      /* Ne consomme rien tant que le carrousel n'est pas à l'écran. */
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.visible = entry.isIntersecting;
          this.visible ? this.startAutoplay() : this.stopAutoplay();
        },
        { rootMargin: '100px' }
      );
      this.observer.observe(this);

      this.onVisibility = () => {
        document.hidden ? this.stopAutoplay() : this.startAutoplay();
      };
      document.addEventListener('visibilitychange', this.onVisibility);

      this.layout();
      this.dataset.ready = '';
    }

    disconnectedCallback() {
      this.initObserver?.disconnect();
      clearTimeout(this.initFallback);
      this.stopAutoplay();
      clearTimeout(this.resumeTimer);
      clearTimeout(this.settleTimer);
      cancelAnimationFrame(this.raf);
      this.observer?.disconnect();
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      this.mobileQuery?.removeEventListener('change', this.onBreakpoint);
      this.tabletQuery?.removeEventListener('change', this.onBreakpoint);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    /* ---- Dimensions ---- */

    /* matchMedia plutôt que window.innerWidth : aucune lecture de mise en page. */
    get isMobile() {
      return this.mobileQuery.matches;
    }

    slidesPerView() {
      if (this.isMobile) return 1;
      if (this.tabletQuery.matches) return Number(this.dataset.countTablet) || 4;
      return Number(this.dataset.count) || 6;
    }

    /**
     * Fixe la largeur d'une photo en pixels. Un pourcentage ne conviendrait pas :
     * la piste déborde du conteneur, donc les pourcentages se résoudraient
     * contre une largeur elle-même dictée par le contenu.
     */
    layout() {
      const width = this.viewport.clientWidth;
      const mode = this.isMobile ? 'mobile' : String(this.slidesPerView());
      if (!width || (width === this.lastWidth && mode === this.lastMode)) return;
      this.lastWidth = width;
      this.lastMode = mode;

      const gap = this.isMobile ? 0 : Number(this.dataset.gap) || 0;

      if (this.isMobile) {
        const ratio = (Number(this.dataset.mobileWidth) || 50) / 100;
        this.slideWidth = Math.round(width * ratio);
        this.style.setProperty('--mk-cc-edge', `${Math.round((width - this.slideWidth) / 2)}px`);
      } else {
        const count = this.slidesPerView();
        this.slideWidth = Math.round((width - gap * (count - 1)) / count);
        this.style.setProperty('--mk-cc-edge', '0px');
      }

      this.style.setProperty('--mk-cc-slide-width', `${this.slideWidth}px`);
      this.step = this.slideWidth + gap;
      this.setWidth = this.originals.length * this.step;
      this.activeIndex = -1;

      this.fillTrack(width);
      this.recenter(true);
      this.updateActive();
      this.startAutoplay();
    }

    /**
     * Duplique le jeu d'origine jusqu'à couvrir la fenêtre plus deux jeux, de
     * quoi absorber les sauts de boucle sans jamais atteindre un bord.
     */
    fillTrack(viewportWidth) {
      const needed = Math.max(4, Math.ceil(viewportWidth / this.setWidth) + 3);
      const current = this.track.children.length / this.originals.length;

      if (current === needed) return;

      for (const node of this.originals) node.classList.remove('is-active');
      this.activeSlide = null;

      const fragment = document.createDocumentFragment();
      fragment.append(...this.originals);
      for (let i = 1; i < needed; i++) {
        for (const node of this.originals) {
          const clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          /* Les doublons sont décoratifs : texte alternatif vide, pour ne pas
             répéter quatre fois le même alt aux moteurs et lecteurs d'écran. */
          clone.querySelector('img')?.setAttribute('alt', '');
          clone.querySelector('.mk-creator-slide__verified')?.removeAttribute('aria-label');
          /* Leurs liens sortent aussi de la navigation au clavier, sinon on
             passerait quatre fois par chaque photo avec la touche Tab. */
          for (const link of clone.querySelectorAll('a')) link.setAttribute('tabindex', '-1');
          fragment.appendChild(clone);
        }
      }
      /* Une seule insertion dans le DOM, donc un seul recalcul de mise en page. */
      this.track.replaceChildren(fragment);
    }

    /* ---- Boucle infinie ---- */

    /** Ramène le scroll dans le jeu du milieu, sans transition visible. */
    recenter(force = false) {
      if (!this.setWidth || this.animating || this.dragging) return;

      if (force) {
        this.viewport.scrollLeft = this.setWidth;
        return;
      }

      const left = this.viewport.scrollLeft;
      if (left < this.setWidth * 0.5) {
        this.viewport.scrollLeft = left + this.setWidth;
      } else if (left > this.setWidth * 1.5) {
        this.viewport.scrollLeft = left - this.setWidth;
      }
    }

    onScroll() {
      if (!this.scrollTicking) {
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.scrollTicking = false;
          this.updateActive();
        });
      }

      /* Pendant l'animation automatique, le recentrage est fait à la fin : pas
         besoin de réarmer un minuteur à chaque image. */
      if (this.animating || this.dragging) return;

      /* Le recentrage n'a lieu qu'une fois le défilement retombé, pour ne pas
         interrompre un glissement en cours. */
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.recenter(), 150);
    }

    /* ---- Défilement automatique ---- */

    startAutoplay() {
      this.stopAutoplay();
      if (this.dataset.autoplay !== 'true' || this.reduceMotion) return;
      if (!this.visible || this.paused || document.hidden) return;

      const interval = Number(this.dataset.interval) || 2000;
      this.timer = setInterval(() => this.next(), interval);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    /* Avance d'une photo, calée sur un cran pour ne jamais dériver. */
    next() {
      if (!this.step || this.animating) return;
      const start = this.viewport.scrollLeft;
      this.animateTo(Math.round(start / this.step) * this.step + this.step);
    }

    /**
     * Fait glisser jusqu'à une position en 500 ms, comme la référence.
     * L'animation est faite à la main : Safari ignore ou annule un scrollBy
     * smooth sur un conteneur à scroll-snap. Le snap est coupé le temps du
     * mouvement puis rétabli.
     */
    animateTo(target) {
      const viewport = this.viewport;
      const start = viewport.scrollLeft;
      const duration = 500;
      const startedAt = performance.now();
      const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

      this.animating = true;
      viewport.style.scrollSnapType = 'none';

      const tick = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        viewport.scrollLeft = start + (target - start) * ease(progress);

        if (progress < 1) {
          this.raf = requestAnimationFrame(tick);
          return;
        }

        this.endAnimation();
        this.recenter();
      };

      this.raf = requestAnimationFrame(tick);
    }

    endAnimation() {
      cancelAnimationFrame(this.raf);
      this.viewport.style.scrollSnapType = '';
      this.animating = false;
    }

    pause() {
      clearTimeout(this.resumeTimer);
      if (this.animating) this.endAnimation();
      this.paused = true;
      this.stopAutoplay();
    }

    resume() {
      clearTimeout(this.resumeTimer);
      this.paused = false;
      this.startAutoplay();
    }

    /* Laisse retomber le glissement du doigt avant de relancer. */
    resumeLater() {
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(() => this.resume(), 1000);
    }

    /* ---- Glisser à la souris ---- */

    /**
     * Le défilement natif ne répond pas au glisser d'une souris : seuls le
     * doigt, le trackpad et la molette le déplacent. Comme la référence
     * (Slick, option draggable), on suit donc la souris à la main. Le tactile
     * n'est pas concerné et garde le défilement natif.
     */
    setupMouseDrag() {
      this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event));
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault());

      /* Un glisser ne doit pas être pris pour un clic sur une photo. */
      this.addEventListener(
        'click',
        (event) => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        },
        true
      );
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !this.step) return;
      this.pointer = { id: event.pointerId, x: event.clientX, left: this.viewport.scrollLeft };
      this.dragging = false;
    }

    onPointerMove(event) {
      if (!this.pointer || event.pointerId !== this.pointer.id) return;

      if (!this.dragging) {
        /* Quelques pixels de seuil pour qu'un simple clic reste un clic. */
        if (Math.abs(event.clientX - this.pointer.x) < 5) return;

        this.pause();
        this.dragging = true;
        this.pointer.x = event.clientX;
        this.pointer.left = this.viewport.scrollLeft;
        this.viewport.style.scrollSnapType = 'none';
        this.dataset.dragging = '';
        try {
          this.viewport.setPointerCapture(event.pointerId);
        } catch (error) {
          /* Capture indisponible : le glisser fonctionne tant que la souris reste dans la zone. */
        }
      }

      event.preventDefault();

      let left = this.pointer.left - (event.clientX - this.pointer.x);

      /* La boucle reste infinie pendant le glisser : on décale d'un jeu entier. */
      if (left < this.setWidth * 0.5) {
        this.pointer.left += this.setWidth;
        left += this.setWidth;
      } else if (left > this.setWidth * 1.5) {
        this.pointer.left -= this.setWidth;
        left -= this.setWidth;
      }

      this.viewport.scrollLeft = left;
    }

    onPointerUp(event) {
      if (!this.pointer || event.pointerId !== this.pointer.id) return;

      const origin = this.pointer.left;
      this.pointer = null;
      if (!this.dragging) return;

      this.dragging = false;
      delete this.dataset.dragging;
      try {
        this.viewport.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* Déjà relâchée. */
      }

      /* Le clic suit immédiatement le relâchement : on l'ignore une fois. */
      this.suppressClick = true;
      setTimeout(() => {
        this.suppressClick = false;
      }, 0);

      /* Calage sur la photo la plus proche. Un glisser franc, d'au moins 15 %
         d'une photo, avance d'une photo dans son sens même s'il est court. */
      const left = this.viewport.scrollLeft;
      let index = Math.round(left / this.step);
      const delta = left - origin;
      if (Math.abs(delta) > this.step * 0.15 && index === Math.round(origin / this.step)) {
        index += Math.sign(delta);
      }

      this.animateTo(index * this.step);

      /* La souris a pu quitter le carrousel pendant le glisser : pas de
         pointerleave dans ce cas, on relance donc nous-mêmes. */
      if (!this.viewport.matches(':hover')) this.resume();
    }

    /* ---- Photo centrée ---- */

    /**
     * Sur mobile, la photo i est centrée exactement quand scrollLeft vaut
     * i × pas. L'index actif se calcule donc sans aucune mesure de mise en
     * page, et seules deux photos changent de classe à chaque bascule.
     */
    updateActive() {
      if (!this.isMobile || !this.step) return;

      const index = Math.round(this.viewport.scrollLeft / this.step);
      if (index === this.activeIndex) return;

      const slide = this.track.children[index];
      this.activeSlide?.classList.remove('is-active');
      slide?.classList.add('is-active');
      this.activeSlide = slide;
      this.activeIndex = index;
    }

    debounce(fn, wait) {
      let id;
      return (...args) => {
        clearTimeout(id);
        id = setTimeout(() => fn(...args), wait);
      };
    }
  }

  if (!customElements.get('mk-creator-carousel')) {
    customElements.define('mk-creator-carousel', MkCreatorCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mk-size-guide"] && !Shopify.designMode) return;
  try {
    class MkSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.SIZE_MAP = {
        'XS':   { FR: '34', UK: '6',  US: '2'  },
        'S':    { FR: '36', UK: '8',  US: '4'  },
        'M':    { FR: '38', UK: '10', US: '6'  },
        'L':    { FR: '40', UK: '12', US: '8'  },
        'XL':   { FR: '42', UK: '14', US: '10' },
        'XXL':  { FR: '44', UK: '16', US: '12' },
        'XXXL': { FR: '46', UK: '18', US: '14' }
      };
      this.STORAGE_COUNTRY = 'mk_size_country';
      this.STORAGE_UNIT = 'mk_size_unit';
    }

    connectedCallback() {
      try {
        this.rows = JSON.parse(this.dataset.rows || '[]');
      } catch (e) {
        this.rows = [];
      }
      this.hasCols = {
        poitrine: this.dataset.hasPoitrine === 'true',
        longueur: this.dataset.hasLongueur === 'true',
        manches: this.dataset.hasManches === 'true',
        epaules: this.dataset.hasEpaules === 'true'
      };

      this.country = this._restore(this.STORAGE_COUNTRY, 'FR');
      this.unit = this._restore(this.STORAGE_UNIT, 'cm');

      this.countrySelect = this.querySelector('.mk-size-guide__country');
      this.unitButtons = this.querySelectorAll('.mk-size-guide__unit');
      this.tbody = this.querySelector('.mk-size-guide__tbody');

      if (!this.tbody) return;

      if (this.countrySelect) {
        this.countrySelect.value = this.country;
        this.countrySelect.addEventListener('change', (e) => {
          // This block can be nested inside <variant-picker>, which listens for
          // 'change' bubbling up to sync the selected size. Stop it here so this
          // unrelated FR/UK/US control never gets mistaken for a variant change.
          e.stopPropagation();
          this.country = e.target.value;
          this._persist(this.STORAGE_COUNTRY, this.country);
          this._renderRows();
        });
      }

      this.unitButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const u = btn.dataset.unit;
          if (u === this.unit) return;
          this.unit = u;
          this._persist(this.STORAGE_UNIT, this.unit);
          this._updateUnitButtons();
          this._renderRows();
        });
      });

      this._updateUnitButtons();
      this._renderRows();
    }

    _restore(key, fallback) {
      try {
        const v = sessionStorage.getItem(key);
        return v || fallback;
      } catch (e) {
        return fallback;
      }
    }

    _persist(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) { /* indisponible : tant pis */ }
    }

    _updateUnitButtons() {
      this.unitButtons.forEach((btn) => {
        const active = btn.dataset.unit === this.unit;
        btn.classList.toggle('mk-size-guide__unit--active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    _convertSize(label) {
      // Retourne la conversion régionale du label, ou null si non mappable
      if (label == null) return null;
      const key = String(label).trim().toUpperCase();
      const mapping = this.SIZE_MAP[key];
      if (!mapping) return null;
      return mapping[this.country] || null;
    }

    _formatValue(val) {
      if (val === null || val === undefined || val === '') return '—';
      const num = parseFloat(val);
      if (isNaN(num)) return '—';
      if (this.unit === 'inch') {
        const inches = num * 0.3937;
        const rounded = Math.round(inches * 2) / 2;
        return rounded % 1 === 0 ? String(rounded) : rounded.toFixed(1);
      }
      const r = Math.round(num * 10) / 10;
      return r % 1 === 0 ? String(r) : r.toFixed(1);
    }

    _renderRows() {
      const cols = this.hasCols;
      const frag = document.createDocumentFragment();

      this.rows.forEach((row) => {
        const tr = document.createElement('tr');

        // Colonne 1 : Taille (lettre Shopify, fixe)
        const tdSize = document.createElement('td');
        tdSize.className = 'mk-size-guide__td mk-size-guide__td--size';
        tdSize.textContent = row.label;
        tr.appendChild(tdSize);

        // Colonne 2 : Conversion régionale (FR/UK/US)
        const tdCountry = document.createElement('td');
        tdCountry.className = 'mk-size-guide__td mk-size-guide__td--country';
        const converted = this._convertSize(row.label);
        tdCountry.textContent = converted !== null ? converted : '—';
        tr.appendChild(tdCountry);

        // Colonnes mesures (uniquement celles qui ont des données quelque part)
        const appendCell = (key) => {
          if (!cols[key]) return;
          const td = document.createElement('td');
          td.className = 'mk-size-guide__td';
          td.textContent = this._formatValue(row[key]);
          tr.appendChild(td);
        };
        appendCell('poitrine');
        appendCell('longueur');
        appendCell('manches');
        appendCell('epaules');

        frag.appendChild(tr);
      });

      this.tbody.innerHTML = '';
      this.tbody.appendChild(frag);
    }
  }

  if (!customElements.get('mk-size-guide')) {
    customElements.define('mk-size-guide', MkSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-scroll-target]');
    if (!trigger) return;

    const target = document.getElementById(trigger.dataset.scrollTarget);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
